import script from "./templateCompiler.vue?vue&type=script&lang=js"
export * from "./templateCompiler.vue?vue&type=script&lang=js"

const __exports__ = script;

export default __exports__